<app-modal [title]="data.commissionConfig.description" class="density-lower"
[buttons]="true">
    <div class="modal-content">
        <div class="export-actions" *ngIf="!loading">
            <app-button *ngIf="hasPermissionToExportPdf" [disabled]="isExportingPdfDetails" [loading]="isExportingPdfDetails"
                (click)="exportPdfReport()" datacy="button-export-pdf-detail">
                <span>
                Exportar PDF
                </span>
            </app-button>

            <app-button *ngIf="hasPermissionToExportExcel" [disabled]="isExportingExcelDetails" [loading]="isExportingExcelDetails"
                (click)="exportWorksheetReport()" datacy="button-export-xlsx-detail">
                <span>
                Exportar Excel
                </span>
            </app-button>
        </div>

        <div class="center" *ngIf="loading">
            <span> Carregando página {{table.paginator.index}}  </span>
            <mat-spinner diameter="30"></mat-spinner>
        </div>

        <app-table [table]="table"
            (emitPaginatorChanged)="pageChange($event)"
            (emitActionView)="viewProfileDataDetails($event)">
        </app-table>
    </div>
</app-modal>
